module.exports = __webpack_public_path__ + "img/From-Your-Cab.6f2bc125.jpg";